(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4141],{

/***/ 34233:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/play",
      function () {
        return __webpack_require__(54581);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9557,496,2127,77,6538,8417,71,1289,4498,4157,9669,5626,9774,2888,179], function() { return __webpack_exec__(34233); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);